
import mixpanel from 'mixpanel-browser';


export const trackMixPanelEvent = (eventKey, shopName, properties = {}) => {
    if(process.env.REACT_APP_MIXPANEL_APIKEY){
        mixpanel.init(process.env.REACT_APP_MIXPANEL_APIKEY, {debug: false  }); 
        // eventKey = process.env.REACT_APP_MIXPANEL_TEST ? `TEST - ${eventKey}` : eventKey
        eventKey = eventKey
        mixpanel.track(eventKey, {
            unique_id:shopName,
            distinct_id: shopName,
            ...properties
        });
      }
}